module.exports = __webpack_public_path__ + "img/contribute.c6d33db.svg";